'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var useTimeValues_hook = require('./use-time-values.hook-1a18dd0a.js');
var parseTime_util = require('./parse-time.util-fac3de5c.js');

var useAmPmChangeHandler = function (handleChange, hours, minutes) { return React.useCallback(function (selected) {
    var currentHoursValue = hours % 12;
    var newHoursValue = selected === 'pm' ? currentHoursValue + 12 : currentHoursValue;
    handleChange(useTimeValues_hook.generateTimePartString(newHoursValue) + ":" + minutes);
}, [handleChange, hours, minutes]); };

var useAmPmValues = function (min, max) {
    var _a = tslib_es6.__read(parseTime_util.parseTime(min), 1), minHours = _a[0];
    var _b = tslib_es6.__read(parseTime_util.parseTime(max), 1), maxHours = _b[0];
    return [{
            value: 'am',
            disabled: minHours >= 12,
        }, {
            value: 'pm',
            disabled: maxHours < 12,
        }];
};

var AmPmValues = function (_a) {
    var is12h = _a.is12h, value = _a.value, handleChange = _a.onChange, valueHeight = _a.valueHeight, maxVisible = _a.maxVisible, min = _a.min, max = _a.max;
    var _b = useTimeValues_hook.useTimeValues(value, is12h), hours = _b.hours, minutes = _b.minutes, amPm = _b.amPm;
    var handleAmPmChange = useAmPmChangeHandler(handleChange, hours, minutes);
    var amPmValues = useAmPmValues(min, max);
    if (!is12h) {
        return null;
    }
    return (React__default.createElement(useTimeValues_hook.Values, { className: "ampm-list", dataTestId: "ampm-list", dataCy: "ampm-list", values: amPmValues, activeValue: amPm, onClick: handleAmPmChange, valueHeight: valueHeight, maxVisible: maxVisible }));
};

exports.AmPmValues = AmPmValues;
